import imgOne from "../../assets/5.png";
import imgTwo from "../../assets/3.png";

export const rows = [
  {
    id: 1,
    orderId: "#001701",
    img: imgOne,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "29-07-22",
    customer: "Pattrick Leach",
    cost: "98.49",
    shipping: "8.49",
    fulfillment: "Shipped",
    order_status: "Delivered",
  },
  {
    id: 2,
    orderId: "#001702",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "25-07-22",
    customer: "Matric Leach",
    cost: "5.49",
    shipping: "8.49",
    fulfillment: "Failed",
    order_status: "Unshipped",
  },
  {
    id: 3,
    orderId: "#001703",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "10-07-22",
    customer: "Pattrick Leach",
    cost: "45.49",
    shipping: "8.49",
    fulfillment: "In Process",
    order_status: "In Transit",
  },
  {
    id: 4,
    orderId: "#001704",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "16-07-22",
    customer: "Pattrick Leach",
    cost: "12.49",
    shipping: "8.49",
    fulfillment: "Cancelled",
    order_status: "Delivered",
  },
  {
    id: 5,
    orderId: "#001705",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "13-07-22",
    customer: "Pattrick Leach",
    cost: "33.49",
    shipping: "8.49",
    fulfillment: "Fulfilled",
    order_status: "Unshipped",
  },
  {
    id: 6,
    orderId: "#001706",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "09-07-22",
    customer: "Pattrick Leach",
    cost: "56.49",
    shipping: "8.50",
    fulfillment: "In Process",
    order_status: "In Transit",
  },
  {
    id: 7,
    orderId: "#001707",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "19-07-22",
    customer: "Pattrick Leach",
    cost: "34.49",
    shipping: "23.49",
    fulfillment: "Shipped",
    order_status: "Delivered",
  },
  {
    id: 8,
    orderId: "#001708",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "30-07-22",
    customer: "Pattrick Leach",
    cost: "34.49",
    shipping: "8.49",
    fulfillment: "Failed",
    order_status: "Delivered",
  },
  {
    id: 9,
    orderId: "#001709",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "20-07-22",
    customer: "Pattrick Leach",
    cost: "45.49",
    shipping: "8.49",
    fulfillment: "Shipped",
    order_status: "Delivered",
  },
];

export const disputeRows = [
  {
    id: 1,
    orderId: "#001701",
    img: imgOne,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "30-07-22",
    customer: "Pattrick Leach",
    cost: "6.49",
    shipping: "8.49",
    tracking_status: "Delivered",
    dispute_status: "Completed",
  },
  {
    id: 2,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "30-07-22",
    customer: "Pattrick Leach",
    cost: "6.49",
    shipping: "58.49",
    tracking_status: "Delivered",
    dispute_status: "Pending",
  },
  {
    id: 3,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "30-07-22",
    customer: "Pattrick Leach",
    cost: "6.49",
    shipping: "28.49",
    tracking_status: "For-Pickup",
    dispute_status: "Completed",
  },
  {
    id: 4,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "30-07-22",
    customer: "Pattrick Leach",
    cost: "6.49",
    shipping: "18.49",
    tracking_status: "In-Transit",
    dispute_status: "Completed",
  },
  {
    id: 5,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "30-07-22",
    customer: "Pattrick Leach",
    cost: "10.49",
    shipping: "8.49",
    tracking_status: "In-Transit",
    dispute_status: "Pending",
  },
  {
    id: 6,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "30-07-22",
    customer: "Pattrick Leach",
    cost: "13.49",
    shipping: "78.49",
    tracking_status: "Failed",
    dispute_status: "Pending",
  },
  {
    id: 7,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "30-07-22",
    customer: "Pattrick Leach",
    cost: "56.49",
    shipping: "98.49",
    tracking_status: "Failed",
    dispute_status: "Completed",
  },
  {
    id: 8,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "30-07-22",
    customer: "Pattrick Leach",
    cost: "89.49",
    shipping: "8.49",
    tracking_status: "In-Transit",
    dispute_status: "Pending",
  },
  {
    id: 9,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    date: "30-07-22",
    customer: "Pattrick Leach",
    cost: "22.49",
    shipping: "8.49",
    tracking_status: "In-Transit",
    dispute_status: "Pending",
  },
];

export const orderTrackingRows = [
  {
    id: 1,
    orderId: "#001701",
    img: imgOne,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    trackingId: "YT22225445445446456",
    destination: "Netherlands",
    time_in_transit: "11 Days",
    shipping: "8.49",
    dispute: "Shipped",
    order_status: "Completed",
  },
  {
    id: 2,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    trackingId: "YT22225445445446456",
    destination: "Netherlands",
    time_in_transit: "11 Days",
    shipping: "8.49",
    dispute: "Shipped",
    order_status: "In Transit",
  },
  {
    id: 3,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    trackingId: "YT22225445445446456",
    destination: "Netherlands",
    time_in_transit: "12 Days",
    shipping: "8.49",
    dispute: "Unshipped",
    order_status: "Completed",
  },
  {
    id: 4,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    trackingId: "YT22225445445446456",
    destination: "Netherlands",
    time_in_transit: "11 Days",
    shipping: "8.49",
    dispute: "Unshipped",
    order_status: "In Transit",
  },
  {
    id: 5,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    trackingId: "YT22225445445446456",
    destination: "Netherlands",
    time_in_transit: "09 Days",
    shipping: "8.49",
    dispute: "Resend",
    order_status: "Unshipped",
  },
  {
    id: 6,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    trackingId: "YT22225445445446456",
    destination: "Netherlands",
    time_in_transit: "19 Days",
    shipping: "8.49",
    dispute: "Shipped",
    order_status: "Unshipped",
  },
  {
    id: 7,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    trackingId: "YT22225445445446456",
    destination: "Netherlands",
    time_in_transit: "10 Days",
    shipping: "8.49",
    dispute: "Unshipped",
    order_status: "Completed",
  },
  {
    id: 8,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    trackingId: "YT22225445445446456",
    destination: "Netherlands",
    time_in_transit: "11 Days",
    shipping: "8.49",
    dispute: "Unshipped",
    order_status: "Unshipped",
  },
  {
    id: 9,
    orderId: "#001701",
    img: imgTwo,
    title: "Foundation Flip Flop",
    category: "Footwear",
    variant: "Sports",
    color: "gray",
    invoiceId: "INVSD750073X",
    productId: "S90M032",
    trackingId: "YT22225445445446456",
    destination: "Netherlands",
    time_in_transit: "11 Days",
    shipping: "8.49",
    dispute: "Shipped",
    order_status: "Unshipped",
  },
];
export const letters = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const dummyOrdersForSkeleton = [
  {
    orderId:1
  },
  {
    orderId:2
  },
  {
    orderId:3
  },
  {
    orderId:4
  },
  {
    orderId:5
  },
  {
    orderId:6
  },
  {
    orderId:7
  },
  {
    orderId:8
  },
  {
    orderId:9
  },
  {
    orderId:10
  },
  {
    orderId:11
  },
  {
    orderId:12
  }
];
export const dummyProductVariants = [
  {
    id:1
  },
  {
    id:2
  },
  {
    id:3
  },
  {
    id:4
  },
];
